import Categories from '@/clients/categories'
import Products from '@/clients/products'
import Validation from '@/clients/validation'
import CvrRegistry from '@/clients/cvrRegistry'
import ShopOrder from '@/clients/shopOrder'
import Prices from '@/clients/prices'
import Cart from '@/clients/cart'
import Anumbers from '@/clients/a-numbers'
import Payment from '@/clients/payment'
import CategoryHeader from '@/clients/categoryHeader'
import PageResources from '~/clients/pageResources'
import Osm from '~/clients/osm'
import Terms from '~/clients/terms'
import Inventory from '~/clients/inventory'
import Customer from '~/clients/customer';
import MitId from '~/clients/mitId';
import Subscriptions from '~/clients/subscriptions';
import Checkout from '~/clients/checkout';
import Authentication from '~/clients/authentication';
import AccountManager from '~/clients/accountManager';
import PlayMix from '~/clients/playmix';
import Events from '~/clients/event';
import heylink from '~/clients/heylink';
import FamilySubscription from '~/clients/familySubscription'
import ShoppingList from '~/clients/shoppingList'
import roamingPrices from '~/clients/roamingPrices';
import Lead from '~/clients/lead';
import Discounts from '~/clients/discounts';

export default ($axios) => ({
  shopOrder: ShopOrder($axios),
  cvrRegistry: CvrRegistry($axios),
  validation: Validation($axios),
  categories: Categories($axios),
  products: Products($axios),
  prices: Prices($axios),
  cart: Cart($axios),
  categoryHeader: CategoryHeader($axios),
  pageResources: PageResources($axios),
  aNumbers: Anumbers($axios),
  payment: Payment($axios),
  osm: Osm($axios),
  customer: Customer($axios),
  terms: Terms($axios),
  inventory: Inventory($axios),
  mitID: MitId($axios),
  subscriptions: Subscriptions($axios),
  checkout: Checkout($axios),
  authentication: Authentication($axios),
  accountManager: AccountManager($axios),
  playMix: PlayMix($axios),
  roamingPrices: roamingPrices($axios),
  heylink: heylink($axios),
  familySubscription: FamilySubscription($axios),
  shoppingList: ShoppingList($axios),
  events: Events($axios),
  lead: Lead($axios),
  discounts: Discounts($axios)
})
